<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7317_63413)">
      <path
        d="M11.4107 10.799C11.1835 10.799 10.9992 10.6148 10.9992 10.3875V8.50684H8.99921V10.3875C8.99921 10.6148 8.81495 10.799 8.58769 10.799H6.70703V12.7949H8.58769C8.81495 12.7949 8.99921 12.9792 8.99921 13.2064V15.0871H10.9951V13.2064C10.9951 12.9792 11.1794 12.7949 11.4066 12.7949H13.2914V10.799H11.4107Z"
        fill="#8B90A4"
      />
      <path
        d="M17.1605 4.60156H2.83951C1.53086 4.60156 0 5.34642 0 7.44107V16.3835C0 18.4781 1.53086 19.223 2.83951 19.223H17.1605C18.4691 19.223 20 18.4781 20 16.3835V7.44107C20 5.34642 18.4733 4.60156 17.1605 4.60156ZM14.1152 13.0049C14.1152 13.3435 13.8407 13.618 13.5021 13.618H11.823V15.297C11.823 15.6357 11.5485 15.9102 11.2099 15.9102H8.79012C8.45149 15.9102 8.17696 15.6357 8.17696 15.297V13.618H6.50206C6.16343 13.6203 5.88704 13.3476 5.88477 13.009C5.88477 13.0076 5.88477 13.0062 5.88477 13.0049V10.5892C5.88477 10.2506 6.15931 9.97605 6.49794 9.97605H8.17696V8.29704C8.17696 7.9584 8.45149 7.68387 8.79012 7.68387H11.2058C11.5444 7.68387 11.8189 7.9584 11.8189 8.29704V9.97605H13.4979C13.8366 9.97378 14.113 10.2465 14.1152 10.5851C14.1152 10.5865 14.1152 10.5878 14.1152 10.5892V13.0049Z"
        fill="#8B90A4"
      />
      <path
        d="M12.646 0.778317C12.6009 0.775745 12.5557 0.775745 12.5105 0.778317H7.48991C6.82957 0.74092 6.26394 1.24586 6.22654 1.90615C6.22397 1.95131 6.22397 1.99653 6.22654 2.04169V3.89354H7.04958L7.0537 2.04169C7.0537 1.92235 7.0537 1.60136 7.49403 1.60136H12.5105C12.9508 1.60136 12.9508 1.91824 12.9508 2.04169V3.89354H13.7739V2.04169C13.8113 1.38135 13.3063 0.815766 12.646 0.778317Z"
        fill="#8B90A4"
      />
    </g>
    <defs>
      <clipPath id="clip0_7317_63413">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
